import React, { useEffect, useState, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import CommentItem from "./CommentItem";
import {ToastContainer } from "react-toastify";
import Translate from "../../Multilanguage/Translate";
import { fetchComments } from "../service";
import PostComment from "./PostComment";


let sortType = "latest"

const Comments_container = ({ videoId, projectInfo, setCommentModalOpen, setCommentCount }) => {
  const containerRef = useRef(null);
  const replyInputRef = useRef(null);
  // Close on outside click
  

  const accessToken = useSelector((state) => state?.accessToken?.value);
  const appInfo = useMemo(() => ({
    projectDetails: projectInfo,
    accessToken: accessToken
  }), [projectInfo, accessToken]);
  const theme = projectInfo?.projectConfig?.config?.THEME;
  // 1. State for paged comments and loaded pages
  const [pagedComments, setPagedComments] = useState({});
  const [totalComments, setTotalComments] = useState(0);
  const [loadedPages, setLoadedPages] = useState(new Set());
  const [minPage, setMinPage] = useState(null);
  const [maxPage, setMaxPage] = useState(null);
  const [hasMoreComments, setHasMoreComments] = useState(true);
  const [activeReplyCommentId, setActiveReplyCommentId] = useState(null);

  useEffect(() => {
    if (videoId) {
      _fetchComments(1, sortType, false, videoId, appInfo).catch(err => {
        console.error(err)
      })
    }
  }, [videoId, appInfo]);

  useEffect(() => {
    if (typeof setCommentCount === "function") {
      setCommentCount(totalComments || 0);
    }
  }, [totalComments, setCommentCount]);

  // 2. Helper to flatten comments for rendering
  const getAllComments = () => {
    const pages = Array.from(loadedPages).sort((a, b) => a - b);
    return pages.flatMap(page => pagedComments[page] || []);
  };

  const loadMoreComments = async () => {
    let nextPage = maxPage + 1;
    let prevPage = minPage - 1;
    let fetchPrev = !loadedPages.has(1) && prevPage >= 1;
    let fetchNext = hasMoreComments;

    const requests = [];

    if (fetchPrev) requests.push(fetchComments(appInfo, {
        page: prevPage,
        sort: sortType === "New" ? "Latest" : "Popular",
        video_id: videoId,
        timestamp: new Date().getTime()
    }));
    if (fetchNext) requests.push(fetchComments(appInfo,{
        page: nextPage,
        sort: sortType === "New" ? "Latest" : "Popular",
        video_id: videoId,
        timestamp: new Date().getTime()
    }));

    const results = await Promise.all(requests);

    let newPagedComments = { ...pagedComments };
    let newLoadedPages = new Set(loadedPages);

    results.forEach((res, idx) => {
      if (res.data.success && res.data.data.length > 0) {
        const page = fetchPrev && idx === 0 ? prevPage : nextPage;
        /**
         * Remove revertProfileLinks when mobile is version is released[]}
         */
        newPagedComments[page] = res.data.data;
        newLoadedPages.add(page);
        if (page < minPage) setMinPage(page);
        if (page > maxPage) setMaxPage(page);
        setHasMoreComments(res.data.data.length >= res.data.limit);
      } else if (fetchNext && idx === (fetchPrev ? 1 : 0)) {
        setHasMoreComments(false); // Stop if next page is empty
      }
    });

    setPagedComments(newPagedComments);
    setLoadedPages(newLoadedPages);
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setCommentModalOpen && setCommentModalOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setCommentModalOpen]);

  const _comments = getAllComments();

  const _fetchComments = async (page = 1, sort = sortType === "New" ? "Latest" : "Popular", prepend = false, Id, appInfo ) => {
    try {
      const params = {page, sort, video_id : Id, timestamp: new Date().getTime()};
      const response = await fetchComments(appInfo, params);
      if (response.data.success) {
        const page = response.data.page;
        setPagedComments({[page]: response.data.data});
        setTotalComments(response.data.total);
        setLoadedPages(new Set([page]));
        setMinPage(page);
        setMaxPage(page);
        setHasMoreComments(response.data.data.length > 10);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  // 1. In the Comment component, add a handler to remove a comment by id:
  const handleDeleteComment = (commentId) => {
    setPagedComments(prev => {
      // Remove the comment from all pages
      const updated = {};
      Object.keys(prev).forEach(page => {
        updated[page] = prev[page].filter(c => c.id !== commentId);
      });
      return updated;
    });
    setTotalComments(prev=>{
        return prev > 0 ? prev - 1 : 0;
    })
  };

  const handleCommentPosted = () => {
    _fetchComments(1, sortType, false, videoId, appInfo).catch(err => {
      console.error(err);
    });
  };

  const handleLike = (commentId, liked, likesCount) => {
    setPagedComments(prev => {
      const updated = {};
      Object.keys(prev).forEach(page => {
        updated[page] = prev[page].map(comment =>
            comment.id === commentId
                ? { ...comment, user_has_liked: liked, likes_count: likesCount }
                : comment
        );
      });
      return updated;
    });
  };
   const closeCommentModal = () => {
    setCommentModalOpen(false);
  };

    return (
      <div ref={containerRef} className={`commentsContainer ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
        <ToastContainer/>

        <div className="bottom">
          <div className="head">
            <span className="commentsCount">{totalComments} <Translate textKey={'comments'}/></span>
             <button className="close-modal" onClick={closeCommentModal}>
                ×
            </button>
          </div>
          <div className="comments">
            {_comments?.map((item) => (
                <CommentItem
                    activeReplyCommentId={activeReplyCommentId} onLike={handleLike}
                    setActiveReplyCommentId={setActiveReplyCommentId} data={item} postID={item.post_id} videoId={videoId} key={item.id}
                    projectInfo={projectInfo} onDelete={() => handleDeleteComment(item.id)}
                    onUpdateContent={(id, newContent) => {
                      setPagedComments(prev => {
                            const updated = {};
                            Object.keys(prev).forEach(page => {
                                updated[page] = prev[page].map(comment =>
                                    comment.id === parseInt(id)
                                        ? { ...comment, content: newContent }
                                        : comment
                                );
                            });
                            return updated;
                        })
                    }}
                />
            ))}
            {/* Load More button: only increases displayCount, no extra fetch */}
            {hasMoreComments && (
                <div className="load-more-btn-div" onClick={loadMoreComments}>
                  Load More Comments
                </div>
            )}
          </div>
        </div>
         <div className="top">
        
          <PostComment postId={videoId} projectInfo={projectInfo} onCommentPosted={handleCommentPosted}/>
        </div>
      </div>
  );
};

export default Comments_container;
